@if (userId && hasUserImage) {
	<img class="small-image" [trigger-soft-popup]="largeImage" [hidden]="!showImage" [userImage]="userId" (onMissingImage)="hasUserImage = false" />
	<soft-popup #largeImage>
		<section><img class="portrait" [userImage]="userId" /></section>
	</soft-popup>
}
@if (userId && !hasUserImage && showImage) {
	<icon type="user" />
}
@if (!userId && showImage) {
	<icon type="user-gear" />
}
<div>
	<div><ng-content /></div>
	@if (showName) { {{ userId ? (userId | user: 'name') : ('general.system-user' | translate) }} }
</div>
